export default function genererCritereRechercheDemandeImpression() {
  return {
    auto: null,
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    societeId: null,
    clientId: null,
    clientIds: [],
    demandeurIds: [],
    receveurIds: [],
    etats: [
    ],
    couleurs: [],
    campagneIds: [],
    dispositifIds: [],
    graphisteIds: [],
    tagIds: [],
    materielTypeLibelles: [],
  };
}
